import React from 'react';
import BuyChart from '../../../components/Chart/BuyChart';
import PropTypes from 'prop-types';
import SaleChart from '../../../components/Chart/SaleChart';

export const BoughtChartCmp = ({ year, isFix, data, error }) => {
  const Chart = isFix ? SaleChart : BuyChart;

  return (
    error || <Chart data={data ? data : []} year={year} />
  );
};

BoughtChartCmp.propTypes = {
  year: PropTypes.number,
  isFix: PropTypes.bool,
  data: PropTypes.array,
  error: PropTypes.func,
};


